"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.0796033,4.93039665 C22.9806039,8.83139725 22.9806039,15.1786027 19.0796033,19.0796033 C15.1786027,22.9806039 8.83139725,22.9806039 4.93039665,19.0796033 C1.02939605,15.1786027 1.02939605,8.83139725 4.93039665,4.93039665 C8.83139725,1.02939605 15.1786027,1.02939605 19.0796033,4.93039665 Z M15.8638746,8.14612545 C15.5086973,7.7909482 14.9327603,7.7909482 14.577583,8.14612545 L12.005,10.7187085 L9.43241697,8.14612545 C9.07723972,7.7909482 8.50130269,7.7909482 8.14612545,8.14612545 C7.7909482,8.50130269 7.7909482,9.07723972 8.14612545,9.43241697 L10.7187085,12.005 L8.14612545,14.577583 C7.7909482,14.9327603 7.7909482,15.5086973 8.14612545,15.8638746 C8.50130269,16.2190518 9.07723972,16.2190518 9.43241697,15.8638746 L12.005,13.2912915 L14.577583,15.8638746 C14.9327603,16.2190518 15.5086973,16.2190518 15.8638746,15.8638746 C16.2190518,15.5086973 16.2190518,14.9327603 15.8638746,14.577583 L13.2912915,12.005 L15.8638746,9.43241697 C16.2190518,9.07723972 16.2190518,8.50130269 15.8638746,8.14612545 Z"
  });
}.bind(void 0));

exports.default = _default;